import React from "react";
import { Link } from "react-router-dom";

function Resume() {
  return (
    <div>
      <section class="section" id="resume">
        <div class="container">
          <h2 class="mb-5">
            <span class="text-danger">My</span> Resume
          </h2>
          <div class="row">
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <div class="card-header">
                  <div class="mt-2">
                    <h4>Expertise</h4>
                    <span class="line"></span>
                  </div>
                </div>
                <div class="card-body">
                
                  <h6 class="title text-danger">2022 - 2023</h6>
                  <p>Front-end Developer</p>
                  <p class="subtitle">
                   FROM CODE-BETTER INDORE
                  </p>
                  <hr />
                  <h6 class="title text-danger">2022 - 2023</h6>
                  <p>UI/GUI Designer</p>
                  <p class="subtitle">
                   FROM CODE-BETTER  INDORE
                  </p>
                  <hr/>
                  <h6 class="title text-danger">2022 - 2023</h6>
                  <p>(DCA)DEPLOMA IN COMPUTER APPLICATION</p>
                  <p class="subtitle">
                   FROM IGM INDORE
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <div class="card-header">
                  <div class="mt-2">
                    <h4>Education</h4>
                    <span class="line"></span>
                  </div>
                </div>
                <div class="card-body">
                  <h6 class="title text-danger">2023 - Present</h6>
                  <p>B.COM </p>
                  <p class="subtitle">
                   FROM BHERULAL COLLAGE DAVV UNIVERSITY
                  </p>
                  <hr />
                  <h6 class="title text-danger">2022 - 2023</h6>
                  <p>REACT-JS Developer </p>
                  <p class="subtitle">
                   FROM CODEBETTER INDORE
                  </p>
                  <hr/>
                  <h6 class="title text-danger">2022 - 2023</h6>
                  <p>Diploma in Computer Apllication</p>
                  <p class="subtitle">
                   FROM IGM Computer MHOW
                  </p>
                  <hr />
                  <h6 class="title text-danger">2020 - 2022</h6>
                  <p>High School Degree</p>
                  <p class="subtitle">
                    KENDRIYA VIDHYALAYA MHOW</p>

                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card">
                       <div class="card-header">
                            <div class="pull-left">
                                <h4 class="mt-2">Skills</h4>
                                <span class="line"></span>  
                            </div>
                        </div>
                        <div class="card-body pb-2">
                           <h6>HTML  &amp; CSS &amp; Bootstrap &amp; jquery </h6>
                            <div class="progress mb-3">
                                <div class="progress-bar bg-danger" role="progressbar" style={{width: "100%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>JavaScript</h6>
                            <div class="progress mb-3">
                                <div class="progress-bar bg-danger" role="progressbar" style={{width: "85%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>REACT</h6>
                            <div class="progress mb-3">
                                <div class="progress-bar bg-danger" role="progressbar" style={{width: "80%"}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>SQL</h6>
                            <div class="progress mb-3">
                                <div class="progress-bar bg-danger" role="progressbar" style={{width: "70%"}} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                        
                        </div>
                    </div>
                    <div class="card">
                       <div class="card-header">
                            <div class="pull-left">
                                <h4 class="mt-2">Languages</h4>
                                <span class="line"></span>  
                            </div>
                        </div>
                        <div class="card-body pb-2">
                           <h6>English</h6>
                            <div class="progress mb-3">
                                <div class="progress-bar bg-danger" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>HINDI</h6>
                            <div class="progress mb-3">
                                <div class="progress-bar bg-danger" role="progressbar" style={{width: "45%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                           
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        </div>
        <div className="STYLE">
        <Link to="https://app.enhancv.com/share/a2bbd066/?utm_medium=growth&utm_campaign=share-resume&utm_source=dynamic">
        <button className="BUTTON">
          RESUME
          <div id="clip">
            <div id="leftTop" className="corner"></div>
            <div id="rightBottom" className="corner"></div>
            <div id="rightTop" className="corner"></div>
            <div id="leftBottom" className="corner"></div>
          </div>
          <span id="rightArrow" className="arrow"></span>
          <span id="leftArrow" className="arrow"></span>
        </button>
      </Link>
     </div>

     </section>
    
     </div>
     


    )
}
export default Resume